import { render, staticRenderFns } from "./viewBackup.vue?vue&type=template&id=40fed2cd&"
import script from "./viewBackup.vue?vue&type=script&lang=js&"
export * from "./viewBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports